import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { filter, map, tap } from 'rxjs/operators';
import { pipe } from 'rxjs';

@Injectable()
export class EuiFileUploadUtilsService {

    constructor(private httpClient: HttpClient) {}

    public sendData(data: any, APIEndPoint: string) {
        return this.httpClient.post(APIEndPoint, this.toFormData(data), {
            reportProgress: true,
            observe: 'events',
        });
    }

    public toFormData<T>(formValue: any) {
        const formData = new FormData();

        for (const key of Object.keys(formValue)) {
            if (Array.isArray(formValue[key])) {
                let fileIndex = 0;
                formValue[key].forEach((value: any) => {
                    if (value instanceof File) {
                        formData.append(key + fileIndex, value);
                        fileIndex ++;
                    }
                });

                const a = [];
                formValue[key].forEach((value: any, index: number) => {
                    a.push(value);
                });

                formData.append(key, JSON.stringify(a));
            } else {
                if (typeof formValue[key] === 'string') {
                    formData.set(key, formValue[key]);
                } else {
                    formData.set(key, JSON.stringify(formValue[key]));
                }
            }
        }

        return formData;
    }

    public uploadProgress<T>(cb: (progress: number) => void) {
        return tap((event: HttpEvent<T>) => {
            if (event.type === HttpEventType.UploadProgress) {
                cb(Math.round((100 * event.loaded) / event.total));
            }
        });
    }

    public toResponseBody<T>() {
        return pipe(
            filter((event: HttpEvent<T>) => event.type === HttpEventType.Response),
            map((res: HttpResponse<T>) => res.body),
        );
    }
}
